'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useAnalytics } from '@workspace/analytics/hooks/use-analytics';

import type { User } from 'next-auth';
import type { ProfileDto } from '~/types/dtos/profile-dto';

type PostHogUserIdentifierProps = {
  user: User;
  profile?: ProfileDto;
};

export function PostHogUserIdentifier({ user, profile }: PostHogUserIdentifierProps) {
  const analytics = useAnalytics();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const identifyAndTrack = async () => {
      if (user.id && analytics) {
        await analytics.identify(user.id, {
          name: profile?.name || user.name || '',
          email: profile?.email || user.email || '',
        });
        // Track first pageview after identification
        const url = [pathname, searchParams.toString()].filter(Boolean).join('?');
        analytics.trackPageView(url);
      }
    };
    identifyAndTrack();
  }, [analytics, user, profile, pathname, searchParams]);

  return null;
}
